import { render, staticRenderFns } from "./SendToValidationModal.vue?vue&type=template&id=d5728f96"
import script from "./SendToValidationModal.vue?vue&type=script&lang=js"
export * from "./SendToValidationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports